<p-card class="hidden"></p-card>
<p-message class="hidden"></p-message>
<p-blockui [blocked]="loading.show" />
@if (loading.show) {
  <div
    class="w-screen h-screen flex justify-center items-center loading-spinner fixed"
  >
    <p-progress-spinner ariaLabel="loading" class="absolute" />
  </div>
}
<p-toast
  key="global-toast"
  class="md:!right-[calc(((100%_-_768px)_/_2)_+_20px)]"
>
  <ng-template let-message #message>
    <div class="flex flex-col gap-2 w-full">
      <div class="flex gap-2 items-center">
        <i [class]="'toast.icon' | translate: { type: message.severity }"></i>
        <div
          class="font-bold p-toast-summary"
          [innerHTML]="message.summary"
        ></div>
      </div>
      <div class="p-toast-detail" [innerHTML]="message.detail"></div>
    </div>
  </ng-template>
</p-toast>
<p-confirmdialog
  [position]="'top'"
  key="global-confirmdialog"
  styleClass="md:!mr-[calc(((100%_-_768px)_/_2)_+_20px)] md:!ml-[calc(((100%_-_768px)_/_2)_+_20px)] px-[var(--p-dialog-header-padding)]"
>
  <ng-template let-message #message>
    <div class="flex flex-col gap-2 py-30">
      <div class="p-confirmdialog-message" [innerHTML]="message.message"></div>
    </div>
  </ng-template>
</p-confirmdialog>
<router-outlet />
